import styled from 'styled-components';
import { Accordion } from '@lendi-ui/accordion';
import { mb } from '@lendi-ui/spacing';

export const CategoryAccordionContentWrapper = styled(Accordion.Content)`
  &:last-child {
    ${mb('xs')};
  }
`;
